import React from 'react';

const Required = () => {
    return (
        <span style={{color: '#dc3545'}}>*</span>
    )
}

export default Required;